export class CandidateOtherSkillsClass {
    id?: number;
    driversLicense?: string[];
    practiceYear?: number;
    practicePosition?: string;
    graduate?: boolean;
    additionalPersonalSkills?: string;
}
